import React, {Component} from "react";
import {connect} from "react-redux"
import {getSpecialtiesList} from "../store/actions/specialtyActions";
import {withTranslate} from 'react-redux-multilingual';
import {setSmallBoneSkeleton} from "../skeleton";
import {withRouter} from "react-router-dom";
import {
    clearDoctorList,
    requestDoctorsPage,
    setSearchData,
    clearSearchData,
    searchFromFooter
} from "../store/actions/doctorActions";

class Footer extends Component {
    componentDidMount() {
        this.props.getSpecialtiesList(1);

    }

    handleSpecialtyClick = async (e, specialty) => {
        e.preventDefault();
        await this.props.clearSearchData();
        this.props.searchFromFooter(true);
        let postData = {};
        if (specialty) {
            postData.keyword = "";
            postData.specialty = {...specialty};
            this.props.setSearchData(postData);
            if (window.location.href.includes("doctors")) {
                window.scroll(0, 0);
                this.props.clearDoctorList();
                this.props.requestDoctorsPage(1, specialty.slug, "", null, null, null, null);
            } else {
                this.props.history.push("/doctors");
            }
        }
    };
    clearSearch = (e) => {
        e.preventDefault();
        localStorage.removeItem("searchData");
        window.location.href = "/doctors";
    };

    render() {
        // set footer style to default
        let footer = document.getElementById("footer");
        if (this.props.route && this.props.route.includes("offer") && !this.props.route.includes("offers")) {
            if (footer) {
                footer.classList.add("offer-details-footer")
            }
        }else {
            if (footer) {
                footer.classList.remove("offer-details-footer")
            }
        }
        const {specialties} = this.props;
        const specialtiesList = specialties ? specialties.map(specialty => {
            return (
                <li className="nav-item mb-0 full-width align-right-rtl dark-blue" key={specialty.slug}>
                    <a className=" d-block mb-0 pb-0 cursor-pointer"
                       onClick={(e) => this.handleSpecialtyClick(e, specialty)}>{specialty.speciality}</a>
                </li>
            )
        }) : null;

        return (
            <footer id="footer" className="ftco-footer img">
                <div className="container">
                    <hr/>
                    <div className="links-box row flex flex-direction-row justify-content-between ">
                        <div className="footer-box-area">
                            <div className="ftco-footer-widget no-margin">
                                <h2 className="ftco-heading-2">{this.props.translate("featured_specialties")}</h2>
                                <div className="block-23 no-margin">
                                    <ul>

                                        {this.props.specialties.length ? specialtiesList : (
                                            <div>
                                                {setSmallBoneSkeleton(8)}
                                            </div>
                                        )}

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="footer-box-area">
                            <div className="ftco-footer-widget">
                                <h2 className="ftco-heading-2 loon">{this.props.translate("important")}</h2>
                                <ul className="list-unstyled">
                                    {/* <li className="align-right-rtl"><a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/watch?v=fUcTdObF8NU"
                                           className=" d-block">{this.props.translate("how_to_register")}</a></li>*/}

                                    <li className="align-right-rtl"><a href="/privacy"
                                                                       className="d-block">
                                        {
                                            this.props.translate("privacy_title")
                                        }</a>
                                    </li>
                                    <li className="align-right-rtl"><a href="/terms"
                                                                       className="d-block">
                                        {
                                            this.props.translate("terms_title")
                                        }</a>
                                    </li>
                                    <li className="align-right-rtl capitalized"><a href="/payment"
                                                                       className="d-block">
                                        {
                                            this.props.translate("payment_terms_title")
                                        }</a>
                                    </li>
                                    <li className="align-right-rtl capitalized"><a href="/download"
                                                                                   className="d-block">
                                        {
                                            this.props.translate("download")
                                        }</a></li>
                                    <li className="align-right-rtl">
                                        <a href="/premium"
                                           className="d-block">
                                            {
                                                this.props.translate("premium_footer")
                                            }
                                        </a>
                                    </li>
                                    <li className="align-right-rtl">
                                        <a href="/cash-back"
                                           className="d-block">
                                            {
                                                this.props.translate("cash_back")
                                            }
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="footer-box-area">
                            <div className="ftco-footer-widget mb-4">
                                <h2 className="ftco-heading-2 capitalized">{this.props.translate("account")}</h2>
                                <ul className="list-unstyled">
                                    <li className="align-right-rtl"><a rel="noopener noreferrer" href="/doctor/download"
                                                                       className="d-block capitalized">{this.props.translate("create_account")}</a>
                                    </li>
                                    <li className="align-right-rtl"><a rel="noopener noreferrer" href="/doctor/download"
                                                                       className="d-block">{this.props.translate("join_our_doctors")}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="footer-box-area">
                            <div className="ftco-footer-widget mb-4">
                                <h2 className="ftco-heading-2">{this.props.translate("site_links")}</h2>
                                <ul className="list-unstyled">
                                    <li className="nav-item align-right-rtl">
                                        <a href="/about"
                                           className="d-block">
                                            {
                                                this.props.translate("about")
                                            }
                                        </a>
                                    </li>

                                    <li className="nav-item align-right-rtl">
                                        <a href="/blog"
                                           className="d-block">
                                            {
                                                this.props.translate("blog")
                                            }
                                        </a>
                                    </li>

                                    <li className="nav-item align-right-rtl">
                                        <a href="/offers"
                                           className="d-block">
                                            {
                                                this.props.translate("offers")
                                            }
                                        </a>
                                    </li>


                                    <li className="nav-item align-right-rtl">
                                        <a onClick={(e) => this.clearSearch(e)}
                                           className="d-block cursor-pointer ">
                                            {
                                                this.props.translate("doctors")
                                            }
                                        </a>
                                    </li>

                                    <li className="nav-item align-right-rtl">
                                        <a
                                            className="d-block"
                                            href="/contact">
                                            {
                                                this.props.translate("contact")
                                            }
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>


                        {/*<div className="col-md-3 footer-box-area">
                            <div className="ftco-footer-widget mb-4">
                                <h2 className="ftco-heading-2">{this.props.translate("have_questions")}</h2>

                                <div className="block-23 no-margin">
                                    <ul className="contact-info-footer">

                                        <li className="float-right-rtl">
                                            <span className="icon icon-map-marker"></span>
                                            <a target="_blank" rel="noopener noreferrer"
                                               href="https://www.google.com.eg/maps/place/RK+Anjel/@30.0522316,31.3506658,15z/data=!4m2!3m1!1s0x0:0xf29994b6f5aa58bc?ved=2ahUKEwi5hOLbvoPfAhXbTxUIHZQBBz4Q_BIwCnoECAYQBg"
                                               className="text with-padding ">{this.props.translate("address_details")}</a>
                                        </li>

                                        <li className="float-right-rtl">
                                            <span className="icon icon-phone"></span> <a href="tel://00222713871"
                                                                                         className="with-padding">
                                            +02 22713871 / +02 22713872</a>
                                        </li>


                                        <li className="float-right-rtl">
                                            <span className="icon icon-envelope"></span> <a target="_blank" href="mailto:info@seena-app.com?Subject=Contact"
                                                                                            className="with-padding">
                                            info@seena-app.com</a>
                                        </li>

                                    </ul>

                                </div>
                            </div>
                        </div>*/}
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <ul className="ftco-footer-social list-unstyled float-md-left float-lft text-center full-width mt-25">
                                <li className="ftco-animate icon-space"><a href="https://twitter.com/rklinic_com"
                                                                target="_blank" rel="noopener noreferrer"><span
                                    className="icon-twitter"></span></a></li>
                                <li className="ftco-animate icon-space"><a href="https://www.facebook.com/seenacom"
                                                                target="_blank" rel="noopener noreferrer"><span
                                    className="icon-facebook"></span></a>
                                </li>
                                <li className="ftco-animate"><a href="https://www.instagram.com/seena_app/"
                                                                target="_blank" rel="noopener noreferrer"><span
                                    className="icon-instagram"></span></a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-12">

                            <p className="text-center">
                                <a href="http://rkanjel.com" target="_blank" className="dark-blue"
                                   rel="noopener noreferrer">{this.props.translate("copyright")  }&nbsp; &copy; {new Date().getFullYear()}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        specialties: state.specialty.featured_specialties,
        currentSearchData: state.doctor.currentSearchData,
        route: state.global.route,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSpecialtiesList: (featured) => dispatch(getSpecialtiesList(featured)),
        setSearchData: (data) => dispatch(setSearchData(data)),
        clearDoctorList: () => dispatch(clearDoctorList()),
        clearSearchData: () => dispatch(clearSearchData()),
        searchFromFooter: (data) => dispatch(searchFromFooter(data)),
        requestDoctorsPage: (page, specialtyString, keyword, slug, sort, city_id, province_id) => dispatch(requestDoctorsPage(page, specialtyString, keyword, slug, sort, city_id, province_id)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(withRouter(Footer)));
